import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  location: string;
  text: string;
}
const TestimonialCard = ({
  name,
  location,
  text
}: TestimonialProps) => <div className="bg-white p-4 md:p-5 rounded-2xl border border-gray-200 shadow-md flex flex-col h-full relative" data-id="element-268">
    <div className="absolute -top-3 right-4 bg-brand-secondary text-brand-text px-2.5 py-0.5 rounded-full text-[10px] font-black shadow-sm" data-id="element-269">
      COMPRADOR VERIFICADO
    </div>
    <div className="flex items-center mb-3" data-id="element-270">
      <div className="w-9 h-9 md:w-10 md:h-10 bg-brand-primary text-white rounded-full flex items-center justify-center font-black text-base md:text-lg mr-3 shrink-0 shadow-md" data-id="element-271">
        {name.charAt(0)}
      </div>
      <div data-id="element-272">
        <div className="flex text-brand-secondary mb-0.5" data-id="element-273">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-274" />)}
        </div>
        <p className="font-black text-brand-text text-sm leading-tight" data-id="element-275">
          {name}
        </p>
        <p className="text-[10px] text-brand-steel font-bold uppercase tracking-wider mt-0.5" data-id="element-276">
          {location}
        </p>
      </div>
    </div>
    <p className="text-brand-text font-medium italic flex-grow leading-snug text-xs md:text-sm" data-id="element-277">
      "{text}"
    </p>
  </div>;
export function TestimonialsSection2() {
  const testimonials = [{
    name: 'Andrés G.',
    location: 'Argentina',
    text: 'Empecé a entregar tableros profesionales y pude subir mis precios un 40%. Antes me daba miedo agarrar trabajos grandes, ahora busco activamente mantenimiento industrial. El manual de tablerista vale oro.'
  }, {
    name: 'Luis P.',
    location: 'México',
    text: 'Pensé que el PLC era imposible. Estas guías lo explican tan simple que ya estoy haciendo mantenimiento industrial. Pasé de cambiar focos a programar automatizaciones en menos de un mes.'
  }, {
    name: 'Carlos R.',
    location: 'Colombia',
    text: 'Llevaba 10 años como electricista domiciliario, estancado. Compré el Master Electrotécnico y la sección de comandos me abrió la cabeza. Hoy tengo 3 fábricas como clientes fijos.'
  }, {
    name: 'Javier M.',
    location: 'Chile',
    text: 'Lo mejor es que va directo al grano. Nada de teoría aburrida, te muestra los diagramas y te explica cómo conectarlo en la vida real. La guía de PLC es la más clara que leí en mi vida.'
  }, {
    name: 'Roberto S.',
    location: 'Perú',
    text: 'Estaba cansado de que me regateen el precio por instalar tomacorrientes. Con este sistema aprendí a armar tableros de bombas y ahora cobro por mi conocimiento, no por mi tiempo. 100% recomendado.'
  }];
  return <section className="py-8 md:py-14 px-4 bg-brand-bg" data-id="element-278">
      <div className="max-w-6xl mx-auto" data-id="element-279">
        <div className="text-center mb-8" data-id="element-280">
          <h2 className="text-xl md:text-3xl font-black text-brand-text mb-2 uppercase leading-tight" data-id="element-281">
            LO QUE DICEN LOS TÉCNICOS QUE YA DIERON EL SALTO
          </h2>
          <p className="text-xs md:text-sm text-brand-steel font-bold" data-id="element-282">
            ⭐⭐⭐⭐⭐ 4.9/5 (+2.500 técnicos formados en todo LATAM)
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-283">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-284" />)}
        </div>
      </div>
    </section>;
}